import React, { useState, useEffect } from 'react';
import './RegisterModal.css'; // You will create this CSS file to match the design
import Select from 'react-select';
import moment from "moment"

const RegisterModal = ({ onClose, onRegister, onChange, selectedTimeSlot }) => {
    const handleFormSubmit = (event) => {
        event.preventDefault();
        onRegister();
      };
  
  return (
    <div className="modal-backdrop">
      <div className="register-modal">
        <div className="modal-header">
          <h2>{selectedTimeSlot.service_name} Appointment</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-content">
          <p>Your appointment is with {selectedTimeSlot.title} {selectedTimeSlot.name} on {moment(selectedTimeSlot.date).format('LL')} at {selectedTimeSlot.time}.</p>
          
          <form onSubmit={handleFormSubmit}>
            
            <button type="submit" className="confirm-button">Confirm</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;
